<template>
  <div style="height: 100%; width: 100%; position: relative;">
    <!-- Added loading spinner overlay -->
    <div v-if="isLoading" class="d-flex flex-row align-items-center justify-content-center p-5 rounded shadow-sm "
      style="height: 100%; width: 100%;" ref="loadingBox">

    </div>
    <!-- Hide content while loading -->
    <div v-show="!isLoading" style="height: 100%; width: 100%; position: relative;">
      <vs-tooltip v-if="BotonDescargarArchivos" class="BotonDescargarArchivo">
        <vs-button color="success" style="height: 100%; width: 100%; ; " size="lg" @click="descargarArchivo()"><i
            class="fas fa-download"></i></vs-button>
        <template #tooltip>Descargar Archivo</template>
      </vs-tooltip>
      <!-- Video -->
      <video v-show="tipo === 'video'" ref="videoPlayer" preload="metadata" class="rounded" controls
        style="height: 100%; width: 100%;">

        Tu navegador no soporta la etiqueta de video.
      </video>
      <!-- Imagen -->
      <img v-show="tipo === 'image'" ref="imageViewer" class="rounded" style="height: 100%; width: 100%;"
        alt="Vista previa" />

      <!-- PDF -->
      <iframe v-show="tipo === 'pdf'" ref="pdfViewer" style="width: 100%; height: 100%; border: none;"></iframe>

      <div v-show="tipo === 'verDesdeDrive'" class="reproductorContenido" style="width: 100%; height: 100%;">
        <!-- Ver desde Drive -->
        <iframe ref="verDesdeDrive" style="width: 100%; height: 100%; border: none;"></iframe>
      </div>

      <div v-if="tipo === 'otro'"
        class="d-flex flex-column align-items-center justify-content-center p-5 rounded shadow-sm bg-dark"
        style="max-width: 100%; height: 100%;">
        <div class="mb-4">
          <i class="fas fa-file-alt text-muted" style="font-size: 4rem;"></i>
        </div>
        <h4 class="text-center text-dark mb-2">
          Documento no compatible
        </h4>
        <p class="text-center text-muted mb-4">
          Este tipo de documento no puede ser visualizado en el navegador. Por favor, descárgalo para verlo.
        </p>
        <b-button variant="success" size="lg" @click="descargarArchivo()" class="d-flex align-items-center">
          <i class="fas fa-download mr-2"></i>
          Descargar archivo
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from 'sweetalert2';
export default {
  name: "ArchivoViewer",
  props: {
    fileId: { type: String },
    DescargarArchivos: { type: Boolean, default: true },
    BotonDescargarArchivos: { type: Boolean, default: true }
  },
  data() {
    return {
      tipo: null, // video | image | pdf | otro
      url: null,
      isLoading: false,
      loadingInstance: null
    };
  },
  mounted() {
    this.validarURL();
  },
  methods: {
    validarURL() {
      console.log("[validarURL], MOUNTED CONTENIDO HELEXIUM");
      if (this.fileId == null || this.fileId === "") {
        this.tipo = "image";
        this.$refs.imageViewer.src = "/img/image_cursos_alt.png";
      }
      else if (this.fileId.startsWith("http") || this.fileId.startsWith("https")) {

        if (this.fileId.endsWith(".pdf")) {
          this.BotonDescargarArchivos = false;
          this.tipo = "pdf";
          this.$refs.pdfViewer.src = this.fileId;
          return;
        }
        else if (this.fileId.match(/\.(mp4|webm|ogg)$/i)) {
          this.tipo = "video";
          this.$refs.videoPlayer.src = this.fileId;
          return;
        }
        else if (this.fileId.match(/\.(jpg|jpeg|png|gif|bmp|svg)$/i)) {
          this.tipo = "image";
          this.$refs.imageViewer.src = this.fileId;
          return;
        }



      }
      else {
        this.ServirArchivo(this.fileId);
      }
    },
    async ServirArchivo(fileId) {

      console.log("[ServirArchivo], INICIANDO LA CARGA DE ARCHIVO DESDE DRIVE");

      this.isLoading = true;
      this.$nextTick(() => {
        this.loadingInstance = this.$vs.loading({
          target: this.$refs.loadingBox,
          type: "scale",
          text: "Cargando archivo...",
          opacity: "0",
        });
      });

      try {
        let token = localStorage.getItem("tk");
        let res = await fetch(
          this.$store.state.hl_url + `CargaMultimedia/GetFile/${fileId}?descargarArchivo=false`,
          {
            method: "GET",
            headers: {
              Authorization: "Bearer " + token,
            },
          }
        );

        let resParseada = await res.json();
        //console.log("Respuesta parseada:", resParseada);

        let contentType = resParseada.mimeType;
        console.log("[ServirArchivo] respuesta Backend:", contentType);

        if (contentType.startsWith("image/") || contentType === "application/pdf") {

          let resDescargar = await fetch(
            this.$store.state.hl_url + `CargaMultimedia/GetFile/${fileId}?descargarArchivo=true`,
            {
              method: "GET",
              headers: {
                Authorization: "Bearer " + token,
              },
            }
          );

          if (!resDescargar.ok) throw new Error(`Error al obtener el archivo: ${resDescargar.status}`);
          let blob = await resDescargar.blob();

          console.log("Content-Type recibido:", contentType);

          let url = URL.createObjectURL(blob);

          if (contentType.startsWith("image/")) {
            this.tipo = "image";
            this.$refs.imageViewer.src = url;
          }

          else if (contentType === "application/pdf") {
            this.BotonDescargarArchivos = false;
            this.tipo = "pdf";
            this.$refs.pdfViewer.src = url;
          }
        }

        // LÓGICA PARA LA REPRODICCIÓN DE VIDEOS DE LA MANERA MÁS EFICIENTE POSIBLE CON DRIVE
        else if (contentType.startsWith("video/")) {
          // Si el viddeo es menor a 50mb, descargar completo para evitar problemas de buffering y múlktiples requests
          if (resParseada.totalSize < 50000000) {
            console.log("[ServirArchivo] Descargando video, menor a 50mb");

            let resDescargar = await fetch(
              this.$store.state.hl_url + `CargaMultimedia/GetFile/${fileId}?descargarArchivo=true`,
              {
                method: "GET",
                headers: { Authorization: "Bearer " + token },
              }
            );

            if (!resDescargar.ok)
              throw new Error(`Error al obtener el archivo: ${resDescargar.status}`);

            let blob = await resDescargar.blob();
            let url = URL.createObjectURL(blob);

            this.tipo = "video";
            this.$refs.videoPlayer.src = url;
            return;
          }

          // EN CASO DE QUE EL VIDEO PESE MÁS DE 50MB, REPRODUCIRLO POR CHUNKS USANDO SIGNED URL PARA PROTEGER EL ACCESO PÚBLIO DEL ENDPOINT YA QUE AL CARGARLO EN UNA ETIQUETA VIDEO SE HACEN MÚLTIPLES REQUESTS AL SERVIDOR Y NO SE PUEDEN AUTENTICAR
          console.log("[ServirArchivo] Cargando archivo por chunks, mayor a 50mb");
          this.tipo = "video";

          const res = await fetch(`${this.$store.state.hl_url}CargaMultimedia/SignedUrl/${fileId}`, {
            headers: { Authorization: "Bearer " + token }
          });

          const { url } = await res.json();

          console.log("La url del video es: ", url);
          

          this.$refs.videoPlayer.src = url;

          const videoEl = this.$refs.videoPlayer;

          // HE DEJADO ESTE TIMEOUT DE 10s PARA ESPERAR A QUE LLEGUE LA METADATA Y ASÍ EL NAVEGADOR PUEDA REPRODUCIR EL VIDEO PORQUE HAY VIDEOS QUE NO SE PUEDEN REPRODUCIR HASTA QUE NO SE CARGA LA METADATA QUE ES EL VIDEO ENTERO
          let metadataTimeout = setTimeout(async () => {
            console.log("No llegó metadata después de 10s → Fallback a descarga completa…");

            let resDescargar = await fetch(
              this.$store.state.hl_url + `CargaMultimedia/GetFile/${fileId}?descargarArchivo=true`,
              {
                method: "GET",
                headers: { Authorization: "Bearer " + token },
              }
            );

            if (!resDescargar.ok)
              throw new Error(`Error al obtener el archivo: ${resDescargar.status}`);

            let blob = await resDescargar.blob();
            let url = URL.createObjectURL(blob);

            console.log("Fallback aplicado → video descargado completamente.");
            videoEl.src = url;
            videoEl.removeEventListener("loadedmetadata", onLoadedMetadata);

          }, 10000); // 10 segundos

          const onLoadedMetadata = () => {
            console.log("Metadata cargada. El navegador puede reproducir.");
            clearTimeout(metadataTimeout);
            videoEl.removeEventListener("loadedmetadata", onLoadedMetadata);
          };

          videoEl.addEventListener("loadedmetadata", onLoadedMetadata);
        }

        // ELSE PARA NO DESCARGAR LOS ARCHIVOS SI NO QUE DIRECTAMENTE LOS ABRA EN DRIVE
        else {
          //console.log("Respuesta parseada:", resParseada);
          let urlDrive = resParseada.url;
          this.tipo = "verDesdeDrive";
          this.$refs.verDesdeDrive.src = urlDrive;
        }
      } catch (error) {
        console.error("Error cargando archivo:", error);
        this.tipo = "image";
        this.$refs.imageViewer.src = "/img/image_cursos_alt.png";
      } finally {
        this.isLoading = false;
        if (this.loadingInstance) this.loadingInstance.close();
      }
    },

    async descargarArchivo() {
      let token = localStorage.getItem("tk");

      if (!this.fileId) {
        Swal.fire({
          icon: "warning",
          title: "Archivo no encontrado",
          text: "No se ha especificado un archivo para descargar.",
        });
        return;
      }

      Swal.fire({
        title: "Descargando...",
        text: "Por favor espera mientras se descarga el archivo.",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      try {
        let res = null;

        if (this.fileId.startsWith("http") || this.fileId.startsWith("https")) {
          res = await fetch(
            `${this.$store.state.hl_url}CargaMultimedia/DescargarContenidoHelexium?url=${this.fileId}`,
            {
              method: "GET",
              headers: {
                Authorization: "Bearer " + token,
              },
            }
          );
        } else {
          res = await fetch(
            `${this.$store.state.hl_url}CargaMultimedia/GetFile/${this.fileId}?descargarArchivo=true`,
            {
              method: "GET",
              headers: {
                Authorization: "Bearer " + token,
              },
            }
          );

          if (!res.ok) {
            Swal.fire({
              icon: "error",
              title: "Error al descargar",
              text: `No se pudo descargar el archivo: ${res.statusText}`,
            });
            return;
          }
        }

        // Convertir la respuesta en un blob
        const blob = await res.blob();
        const url = window.URL.createObjectURL(blob);

        // Crear enlace temporal y forzar descarga
        const a = document.createElement("a");
        a.href = url;
        a.download = "archivo_descargado";
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);

        Swal.fire({
          icon: "success",
          title: "¡Descarga completada!",
          text: "El archivo se descargó correctamente.",
          timer: 2500,
          showConfirmButton: false,
        });

      } catch (error) {
        console.error("Error al descargar el archivo:", error);
        Swal.fire({
          icon: "error",
          title: "Error inesperado",
          text: "Ocurrió un problema al descargar el archivo. Inténtalo de nuevo.",
        });
      }
    },

  },
  watch: {
    fileId: {
      immediate: false, // se ejecuta también en el primer render
      handler(newVal) {
        if (newVal) this.validarURL(newVal);
      }
    }
  }

};
</script>

<style>
.reproductorContenido {
  position: relative;
}

.completarTarea {
  position: absolute;
  top: 9px;
  right: 11px;
  z-index: 10;
  width: 45px;
  height: 45px;
  border-radius: 10px;
}

.vs-loading {
  left: auto !important;
  top: auto !important;
}

.vs-loading {
  z-index: 2 !important;
}

.BotonDescargarArchivo {
  position: absolute;
  top: 6px;
  right: 16px;
  z-index: 11;
  width: 45px;
  height: 45px;
  border-radius: 10px;

}

@media(max-width: 768px) {
  .BotonDescargarArchivo {
    width: 50px;
    height: 50px;
  }
}
</style>
